export const SCREEN_SUBSCRIPTION_CANCELLED = 'subscriptionCancelled'
export const SCREEN_REOPEN_CONFIRMATION = 'reopenConfirmation'
export const REOPEN_FUNNEL = 'reopen'
export const SCREEN_AGREEMENT_DOCUMENTS = 'reopenAccount'

export const logoutButtonTapped = (ctaTitle: string, screen: string) => ({
  object_name: `${screen}Logout`,
  screen,
  screen_name: screen,
  cta_title: ctaTitle,
})

export const pendingReopenButtonTapped = {
  type: 'button_tapped',
  object_name: 'productPendingReopen',
  screen: 'portfolio',
  screen_name: 'portfolio',
  investment_product: 'invest',
  funnel: REOPEN_FUNNEL,
}
